enum LAZY_SIZES_EVENTS {
    lazyincluded = "lazyincluded"
  }

  const registerFiredEvent = (
    elementId: string,
    callback: (elment: HTMLElement) => void
  ) => {
    const targetId = document.getElementById(elementId);
    // Remove lisenter after call only ONCE
    const wrapCallback = (e: Event) => {
      console.log("lazyincluded", e);
      callback(e.target as HTMLElement);
      if (targetId) {
        targetId.removeEventListener(
          LAZY_SIZES_EVENTS.lazyincluded,
          wrapCallback
        );
      }
    };
    if (targetId) {
      targetId.addEventListener(LAZY_SIZES_EVENTS.lazyincluded, wrapCallback);
    }
  };

  const onLazyIncludedScript = (e: Event) => {
    if (e.target) {
      onLazyIncludedScriptLoaded(e.target as Element)
    }
  }

  const onLazyIncludedScriptLoaded = (targetElement: Element) => {
    const scriptTag = targetElement.querySelector("script");
    if (scriptTag) {
      const script = scriptTag.innerHTML;
      if (script) {
        try {
          eval(`;(function(){${script};})();`); // NOSONAR
        } catch (err) {
          console.warn(`Executing script error: ${script}`, err);
        }
      }
    }
  };

  const enableExternalFileScript = () => {
    // data-include動作しない原因 ：
    // lazysizesがlazyincludedのaddEventListener前に発火された（lazyloadedになってしまう）場合があるので、
    // querySelectorAllで明示的に実行させる(レアケース)
    document.querySelectorAll(".lazyloaded[data-include]").forEach(alreadyLoadedTag=> {
      onLazyIncludedScriptLoaded(alreadyLoadedTag);
    });
    // lazysizesがlazyincludedのEventListenerを登録する(通常ケース)
    document.addEventListener("lazyincluded", onLazyIncludedScript, false);
  };

  const LazyUtil = {
    registerFiredEvent,
    enableExternalFileScript
  };

  export default LazyUtil;
